import _ from "lodash";
import { takeLatest, call, put } from "redux-saga/effects";
import { fetchAllResolutionSummary } from "../../../services/comments";
import * as actions from "../commentActions";

export default function* fetchAllResolutionSummaryWatcher() {
  yield takeLatest(
    actions.FETCH_ALL_RESOLUTION_SUMMARY,
    fetchAllResolutionSummaryWorker,
  );
}

export function* fetchAllResolutionSummaryWorker(action) {
  yield put(actions.loading(true));
  try {
    const response = yield call(fetchAllResolutionSummary, {
      doc_category_id: action.doc_category_id,
      comment_seq_nbr: action.comment_seq_nbr,
      offset: action.offset,
      next: action.next,
      sortField: action.sortField,
      sortDirection: action.sortDirection,
    });
    yield call(success, response);
  } catch (error) {
    yield call(failure, error);
  }
}


export function* success(response) {
  yield put(actions.loading(false));

  const data = _.get(
    response,
    "data.fetchAllResolutionSummaryByComment",
    [],
  );
  yield put(actions.setResolutionSummary(data));
}

export function* failure(error) {
  yield put(actions.loading(false));
  yield put(actions.error(error));
}
